import Script from 'next/script';
import { captcha } from '~/config';

const Recaptcha = () => (
  <Script src={`https://www.google.com/recaptcha/enterprise.js?render=${captcha}`} />
);

async function execute(action: string) {
  return new Promise<string | undefined>((resolve) => {
    if (!window.grecaptcha) {
      console.error(
        'Recaptcha is not loaded, make sure to initialize the script first and call the execute after initialization.'
      );
      resolve(undefined);
    }

    window.grecaptcha.enterprise.ready(() => {
      window.grecaptcha.enterprise.execute(captcha, { action }).then((token: string) => {
        resolve(token);
      });
    });
  });
}

Recaptcha.execute = execute;

export default Recaptcha;
